import React from 'react';
import ProcessGuideApp from './ProcessGuideApp';

function App() {
    return (
        <div className="min-h-screen bg-gray-50">
            <ProcessGuideApp />
        </div>
    );
}

export default App;